<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="bi_code,bi_vendname,bi_remark"
      placeholder="输入单据编号、供应商、备注进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/money/pay_invoice/' + item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.bi_vendname}}</p>
          <p class="list-item-muted">{{item.bi_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.bi_amount}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.bi_status!='已审核'}"
          >{{item.bi_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('bi_amount')}}</em>
    </div>
    
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";

import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/money/billoutap/list",
      filters: [
        {
          type: "date",
          name: "bi_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待确认",
              condition:
                "ifnull(bi_refno,' ')=' ' "
            },
            {
              value: 2,
              label: "已收票",
              condition: "bi_statuscode='AUDITED' and ifnull(bi_refno,' ')<>' '"
            },
          ]
        },
      ]
    };
  }
};
</script>